import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';


class Day extends Component {
  render() {
    let display = "";
    if(this.props.selected) {
      display = this.props.day;
    }  
    return (
      <Dropdown isOpen={this.props.isOpen} toggle={this.props.toggle}>
        <DropdownToggle id="day" name="day" tabIndex="-1">{display}</DropdownToggle>
        <DropdownMenu className="day-dropdown">
          <div className="close" onClick={this.props.toggle}></div>  
          <DropdownItem className="heading link" onClick={this.props.backToMonth}><div className="back"></div>{this.props.month}</DropdownItem>
          {Array.from({length: this.props.numDays}, (v, k) => k+1).map((day, i) =>{
            return (
              <div className="dropdown-item-container" key={i}>
                <DropdownItem name={day} onClick={this.props.select} active={day === this.props.day ? true : null}>{day}</DropdownItem>
              </div>
            );
          })}                            
        </DropdownMenu>          
      </Dropdown>  
      );
  }
}
Day.defaultProps= {
  isOpen: false,
  toggle: () => {},
  select: () => {},
  backToMonth: () => {},
  numDays: 31,
  day: 1,
  selected: false,
  month: ""
};

Day.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  select: PropTypes.func,
  backToMonth: PropTypes.func,
  numDays: PropTypes.number,
  day: PropTypes.number,
  selected: PropTypes.bool,
  month: PropTypes.string
};

export default Day;


// WEBPACK FOOTER //
// ./src/components/DatePicker/Day.js